<template>
    <div class="banniere" role="alert">
        <div class="icon-container">
            <img :alt="$t('accessDenied.iconAlt')" :src="loadCross" class="icon-warning" />
        </div>

        <div class="banniere-content">
            <h3 class="banniere-titre">
                {{ resolvedTitle }}
            </h3>

            <p class="banniere-message">
                {{ resolvedMessage }}
            </p>

            <RouterLink v-if="homePath" :to="homePath" class="banniere-button">
                {{ resolvedHomeText }}
            </RouterLink>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AccessDeniedBanner',

    props: {
        title: {
            type: String,
            default: '',
        },

        message: {
            type: String,
            default: '',
        },

        homePath: {
            type: String,
            default: '/dashboard',
        },

        homeText: {
            type: String,
            default: '',
        },
    },

    computed: {
        loadCross() {
            return require('@/assets/img/warning.png');
        },
        resolvedTitle(): string {
            return this.title || ((this as any).$t('accessDenied.title') as string);
        },
        resolvedMessage(): string {
            return this.message || ((this as any).$t('accessDenied.message') as string);
        },
        resolvedHomeText(): string {
            return this.homeText || ((this as any).$t('accessDenied.home') as string);
        },
    },
});
</script>

<style scoped>
.banniere {
    display: flex;
    align-items: center;
    gap: 20px;

    padding: 24px;

    background: var(--rouge-error-background);
    border: 1px solid var(--rouge-error-border);
    border-radius: 16px;

    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);

    max-width: 700px;
    margin: 24px auto;
}

.icon-container {
    flex-shrink: 0;

    width: 80px;
    height: 80px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: white;
    border-radius: 50%;

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.icon-warning {
    width: 60px;
    height: 60px;
}

.banniere-content {
    flex: 1;
}

.banniere-titre {
    margin: 0 0 8px 0;

    font-size: 20px;
    font-weight: 700;

    color: var(--rouge-error-titre);
}

.banniere-message {
    margin: 0 0 16px 0;

    font-size: 15px;
    line-height: 1.5;

    color: var(--rouge-fonce-error);
}

.banniere-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 10px 16px;

    background: var(--red);
    color: white;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
}

.banniere-button:hover {
    background: var(--rouge-error-titre);
}
</style>
